import { FC, TextareaHTMLAttributes } from 'react';
import * as React from 'react';
import tw, { styled } from 'twin.macro';
import 'styled-components/macro';

import { Form } from './Form';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: React.ReactNode;
  hint?: string;
  error?: string;
  touched?: boolean;
}

export const TextArea: FC<TextAreaProps> = ({ error, label, hint, touched, className, ...rest }) => {
  const hasError = Boolean(touched && error);
  const hintText = hasError && error ? error : hint;

  const control = <StyledTextArea hasError={hasError} rows={4} {...rest} />;

  return (
    <Form.Group className={className}>
      {label ? (
        <Form.Label>
          {label}
          {control}
        </Form.Label>
      ) : (
        control
      )}
      {hintText && <Form.Hint error={hasError}>{hintText}</Form.Hint>}
    </Form.Group>
  );
};

const StyledTextArea = styled.textarea<{
  disabled?: boolean;
  hasError?: boolean;
}>(({ disabled, hasError }) => [
  tw`
    bg-white
    text-primary-medium
    border-1
    border-gray-15
    box-border
    cursor-text
    flex
    px-2
    py-1
    rounded-sm
    transition duration-fast
    w-full
    text-lg
    leading-snug
    placeholder:text-gray-50
    focus:(outline-none text-indigo)
    hover:text-indigo
    disabled:text-gray-30
  `,
  disabled && tw`pointer-events-none bg-white border-gray-15 text-gray-70`,
  hasError
    ? tw`border-error ring ring-error-lightest`
    : tw`focus-within:(border-secondary ring ring-secondary-lighter)`,
]);
